export default __webpack_public_path__ + "static/media/connect-blue.15254786.svg";